import React from 'react';
import './down-arrow.m.css';
export function DownArrow() {
  return <i styleName="down-arrow" className="icon-ic_expand" />;
}

DownArrow.propTypes = {};
